import { useNotifications } from './Notifications.hooks';
import { NotificationsView } from './NotificationsView';

export const Notifications = () => {
  const { reportingModuleNotifications, flaModuleNotifications, isLoading } =
    useNotifications();

  return (
    <NotificationsView
      reportingModuleNotifications={reportingModuleNotifications}
      flaModuleNotifications={flaModuleNotifications}
      isLoading={isLoading}
    />
  );
};
